import { Module } from "@webmotors/ioc";
import { ApiService } from "./api.service";
import { HttpModule } from "../http";

export const ApiModule: Module = {
  name: "ApiModule",
  modules: [HttpModule],
  providers: [ApiService],
};
